module.exports = __webpack_public_path__ + "static/media/6010766-uhd_3840_2160_25fps.c785f78d.mp4";